//revenue start
import { IEltCompanyPerformanceItem } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltCompanyPerfomance'
import { IEltCustomerRevenue } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltCustomerRevenue'
import { IAvtSettings } from 'legacy/lut/classes/models/partner360/ELT/IAvtSettings'
import { IPLCParams } from 'legacy/lut/classes/models/partner360/ELT/IPLCParams'

import { Nullable } from 'clickNgo/models/utils'

import { IHpSobSnapshot } from './financialData/hpSob/IHpSobSnapshot'
import { IBasicInfo } from './financialData/IBasicInfo'
import { IPriority } from './financialData/IPriority'
import { IKpi } from './financialData/kpi/IKpi'
import { ISellThruFields } from './financialData/Revenue'

export interface IRevenueSnapshot extends ISellThruFields {}

export const revenuePSByMarkets = [
  //emea
  'RevenuePersonalSystemsSouthMiddleEuropeAndAfrica',
  'RevenuePersonalSystemsCentralEastEurope',
  'RevenuePersonalSystemsNorthEurope',

  //apj
  'RevenuePersonalSystemsAsia',
  'RevenuePersonalSystemsIndiaAndBSL',
  'RevenuePersonalSystemsChina',

  //ams
  'RevenuePersonalSystemsLatinAmerica',
  'RevenuePersonalSystemsNorthAmerica',
]

export const revenuePrintByMarkets = [
  //emea
  'RevenuePrintSouthMiddleEuropeAndAfrica',
  'RevenuePrintCentralEastEurope',
  'RevenuePrintNorthEurope',

  //apj
  'RevenuePrintAsia',
  'RevenuePrintIndiaAndBSL',
  'RevenuePrintChina',

  //ams
  'RevenuePrintLatinAmerica',
  'RevenuePrintNorthAmerica',
]

export const revenueSuppliesByMarkets = [
  //emea
  'RevenueSuppliesSouthMiddleEuropeAndAfrica',
  'RevenueSuppliesCentralEastEurope',
  'RevenueSuppliesNorthEurope',

  //apj
  'RevenueSuppliesAsia',
  'RevenueSuppliesIndiaAndBSL',
  'RevenueSuppliesChina',

  //ams
  'RevenueSuppliesLatinAmerica',
  'RevenueSuppliesNorthAmerica',
]

export const revenuePolyByMarkets = [
  //emea
  'RevenuePolySouthMiddleEuropeAndAfrica',
  'RevenuePolyCentralEastEurope',
  'RevenuePolyNorthEurope',

  //apj
  'RevenuePolyAsia',
  'RevenuePolyIndiaAndBSL',
  'RevenuePolyChina',

  //ams
  'RevenuePolyLatinAmerica',
  'RevenuePolyNorthAmerica',
]

export const totalByMarkets = [
  'PersonalSystemsByMarketsTotal',
  'PrintByMarketsTotal',
  'SuppliesByMarketsTotal',
  'PolyByMarketsTotal',
]

export const allTotalRows = [...totalByMarkets, 'GrandTotal']

export const revenueGroupedByMarket: Record<string, string[]> = {
  'Latin America': [
    'RevenuePersonalSystemsLatinAmerica',
    'RevenuePrintLatinAmerica',
    'RevenueSuppliesLatinAmerica',
    'RevenuePolyLatinAmerica',
  ],
  'Greater China': [
    'RevenuePersonalSystemsChina',
    'RevenuePrintChina',
    'RevenueSuppliesChina',
    'RevenuePolyChina',
  ],
  'Greater Asia': [
    'RevenuePersonalSystemsAsia',
    'RevenuePrintAsia',
    'RevenueSuppliesAsia',
    'RevenuePolyAsia',
  ],
  'India, B&SL': [
    'RevenuePersonalSystemsIndiaAndBSL',
    'RevenuePrintIndiaAndBSL',
    'RevenueSuppliesIndiaAndBSL',
    'RevenuePolyIndiaAndBSL',
  ],
  'North America': [
    'RevenuePersonalSystemsNorthAmerica',
    'RevenuePrintNorthAmerica',
    'RevenueSuppliesNorthAmerica',
    'RevenuePolyNorthAmerica',
  ],
  'Northern Europe': [
    'RevenuePersonalSystemsNorthEurope',
    'RevenuePrintNorthEurope',
    'RevenueSuppliesNorthEurope',
    'RevenuePolyNorthEurope',
  ],
  'Central and Eastern Europe': [
    'RevenuePersonalSystemsCentralEastEurope',
    'RevenuePrintCentralEastEurope',
    'RevenueSuppliesCentralEastEurope',
    'RevenuePolyCentralEastEurope',
  ],
  'Southern Europe, Middle East and Africa': [
    'RevenuePersonalSystemsSouthMiddleEuropeAndAfrica',
    'RevenuePrintSouthMiddleEuropeAndAfrica',
    'RevenueSuppliesSouthMiddleEuropeAndAfrica',
    'RevenuePolySouthMiddleEuropeAndAfrica',
  ],
}

export const revenueByMarket = [
  ...revenuePSByMarkets,
  ...revenuePrintByMarkets,
  ...revenueSuppliesByMarkets,
  ...revenuePolyByMarkets,
]

export const revenueSnapshotKeys = [
  //general
  'Revenue3D',
  'PersonalSystemsByMarketsTotal',
  ...revenuePSByMarkets,
  'PrintByMarketsTotal',
  ...revenuePrintByMarkets,
  'SuppliesByMarketsTotal',
  ...revenueSuppliesByMarkets,
  'PolyByMarketsTotal',
  ...revenuePolyByMarkets,
  'GrandTotal',
] as const

// export const revenueSnapshotKeys = [
//   ...revenueByGbu,
//   ...revenuePSByMarkets,
//   ...revenuePrintByMarkets,
//   ...revenueSuppliesByMarkets,
//   ...totalByMarkets,
// ] as const
type typeOfRevenueSnapshotKeys = typeof revenueSnapshotKeys
export type TRevenueSnapshotKeys = typeOfRevenueSnapshotKeys[number]

export type TRevenueSnapshots = Record<TRevenueSnapshotKeys, IRevenueSnapshot>
//revenue end

//market share start

export const competitorsSnapshotKeys = [
  'CompetitorsPersonalSystems',
  'CompetitorsPoly',
  'CompetitorsPrint',
  'CompetitorsSupplies',
] as const

export const competitorsSnapshotDocOctoberKeys = [
  'CompetitorsPersonalSystems',
  'CompetitorsPoly',
  'CompetitorsPolyHeadset',
  'CompetitorsPolyVideo',
  'CompetitorsPrint',
  'CompetitorsSupplies',
] as const

type typeOfCompetitorsSnapshotKeys =
  | typeof competitorsSnapshotKeys
  | typeof competitorsSnapshotDocOctoberKeys
export type TCompetitorsSnapshotKeys = typeOfCompetitorsSnapshotKeys[number]

export interface ICompetitorsSnapshot {
  Name: 'HP' | string
  YoY: number | null
  HPSow: number | null
}

export type TCompetitorsSnapshot = Record<TCompetitorsSnapshotKeys, ICompetitorsSnapshot[]>

export interface IHPContact {
  Email?: string
  FirstName?: string
  LastName?: string
  Roles?: string
  MainPhoneNorm?: string
  MobilePhoneNorm?: string
}

export interface IContact {
  Email?: string
  FirstName?: string
  LastName?: string
  MainPhoneNorm?: string
  WorkPhoneNorm?: string
  MobilePhoneNorm?: string
  Roles?: string
}

export interface IELTFinancialData {
  RTEligible?: number
  AVTSettings: IAvtSettings
  PartnerId: string | null
  GroupId: number | null
  FYear: number
  HPContact?: IHPContact
  PrimaryContact?: IContact
  AdminContact?: IContact
  BasicInfo?: IBasicInfo
  LongTermPriorities?: IPriority[]
  ShortTermPriorities?: IPriority[]
  SellThruDesc: string
  SellToDesc: string
  CompetitorsPersonalSystems: ICompetitorsSnapshot
  CompetitorsPrint: ICompetitorsSnapshot
  CompetitorsSupplies: ICompetitorsSnapshot

  Revenue3D: IRevenueSnapshot

  RevenueSuppliesCentralEastEurope: IRevenueSnapshot
  RevenueSuppliesAsia: IRevenueSnapshot
  RevenueSuppliesChina: IRevenueSnapshot
  RevenueSuppliesIndiaAndBSL: IRevenueSnapshot
  RevenueSuppliesLatinAmerica: IRevenueSnapshot
  RevenueSuppliesNorthAmerica: IRevenueSnapshot
  RevenueSuppliesNorthEurope: IRevenueSnapshot
  RevenueSuppliesSouthMiddleEuropeAndAfrica: IRevenueSnapshot

  RevenuePrintCentralEastEurope: IRevenueSnapshot
  RevenuePrintAsia: IRevenueSnapshot
  RevenuePrintChina: IRevenueSnapshot
  RevenuePrintIndiaAndBSL: IRevenueSnapshot
  RevenuePrintLatinAmerica: IRevenueSnapshot
  RevenuePrintNorthAmerica: IRevenueSnapshot
  RevenuePrintNorthEurope: IRevenueSnapshot
  RevenuePrintSouthMiddleEuropeAndAfrica: IRevenueSnapshot

  RevenuePersonalSystemsCentralEastEurope: IRevenueSnapshot
  RevenuePersonalSystemsAsia: IRevenueSnapshot
  RevenuePersonalSystemsChina: IRevenueSnapshot
  RevenuePersonalSystemsIndiaAndBSL: IRevenueSnapshot
  RevenuePersonalSystemsLatinAmerica: IRevenueSnapshot
  RevenuePersonalSystemsNorthAmerica: IRevenueSnapshot
  RevenuePersonalSystemsNorthEurope: IRevenueSnapshot
  RevenuePersonalSystemsSouthMiddleEuropeAndAfrica: IRevenueSnapshot

  HPSob: IHpSobSnapshot[]

  HasRevenuePolyData?: number
  PLC: IKpi[]
  PLCParams: Nullable<IPLCParams>
  CustomerRevenue?: IEltCustomerRevenue[]
  CompanyPerformance?: IEltCompanyPerformanceItem[]
}
